<template>
  <div class="category">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('string.project_type_list') }}
        </h3>
        <div class="pull-right box-tools">
          <router-link
            v-if="can([Permissions.backend.setting.projectType.store])"
            :to="{ name: 'create-project-type' }"
            class="btn btn-primary btn-sm"
          >
            <i class="fa fa-plus-circle" /> {{ $t("button.add_project_type") }}
          </router-link>
        </div>
      </div>
      <div class="box-body">
        <Datatable
          ref="oTable"
          :columns="columns"
          table-id="project-type-id"
          url="api/backend/project-types/datatable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Permissions from '@/permissions'
import Datatable from '@/components/Datatable'
export default {
  name: 'List',
  metaInfo () {
    return {
      title: this.$t('string.project_type_list'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: { Datatable },
  data () {
    return {
      Permissions
    }
  },
  computed: {
    columns () {
      return [
        {
          data: 'name_en',
          name: 'name_en',
          title: this.$t('table.name_en')
        },
        {
          data: 'name_km',
          name: 'name_km',
          title: this.$t('table.name_km')
        },
        {
          data: 'created_at',
          name: 'created_at',
          width: '200px',
          searchable: false,
          title: this.$t('table.createdAt'),
          render: (data) => {
            return this.getDateFormat(data)
          }
        },
        {
          data: 'action',
          name: 'action',
          title: this.$t('table.action'),
          width: '120px',
          orderable: false,
          searchable: false
        }
      ]
    }
  },
  mounted () {
    this.loadAction()
  },
  methods: {
    loadAction () {
      const self = this
      this.clearEventHandler([
        '.btn-delete',
        '.btn-edit'
      ])

      $(function () {
        $(document).on('click', '.btn-delete', function () {
          self.onDelete($(this).attr('data-uuid'))
        })
      })

      $(document).on('click', '.btn-edit', function () {
        self.$router.push({
          name: 'edit-project-type',
          params: {
            uuid: $(this).attr('data-uuid')
          }
        })
      })
    },
    onDelete (project_type_uuid) {
      this.onConfirm({})
        .then((accept) => {
          if (accept) {
            this.$axios.delete(`${process.env.VUE_APP_API}/api/backend/project-types/${project_type_uuid}`)
              .then(() => {
                this.showSwalSuccess()
                this.$refs.oTable.draw(true)
              })
              .catch((error) => {
                this.onResponseError(error)
              })
          }
        })
    }
  }
}
</script>

<style scoped></style>
